import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { MasonryItemDirective } from '@shared/directives/masonry-item.directive'
import { HotelRepository } from '@core/services/repositories/hotel.repository'
import { RecursiveDestinationsComponent } from "./recursive-destinations/recursive-destinations.component";
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component'
import { cdnUrl } from '../../app.module'


@Component({
  selector: 'iho-international-hotels',
  templateUrl: './international-hotels.component.html',
  styleUrls: ['./international-hotels.component.scss'],
  standalone: true,
  providers: [HotelRepository],
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
    MasonryItemDirective,
    RecursiveDestinationsComponent,
    SkeletonComponent
]
})

export class internationalHotelsComponent implements OnInit {
  hotelRepo = inject(HotelRepository)
 cdnUrl = cdnUrl;
  dataSource: any;
  showIcon: boolean[] = [];
  loading = true


  constructor(  private destroyRef: DestroyRef,
       @Inject(DOCUMENT) private document: Document) {
  }
  ngOnInit(): void {
    console.log("init");
    this.getData()
  }


  getData() {
    this.hotelRepo.getInternationalHotels()
    .subscribe(
      (response) => {
        this.dataSource = response
        this.loading = false
      }
    )
  }
  showMore(index:number,ev:Event) {
    (this.document as any).querySelector(`.showMore-${index}`).previousElementSibling.classList.toggle('max-h-72');
    this.showIcon[index] = !this.showIcon[index];
  }
}
